import { KikCommonUtils } from "@kikocosmeticsorg/uc-api-nest-common-fe";

export class CommonUtils extends KikCommonUtils {}

export default CommonUtils;
